import styled from "styled-components";

import { card, layout } from "/styles";

export const ListContainer = styled.div(card.wrapper);

export const ListWrapper = styled.div(layout.margin("expanded", "none", "none", "none"));
